import React from 'react'
import { ConnectedMap } from '../FormTypes'

interface FormActionHandlers {
  [key: string]: (props: any) => void
}

interface PrequalificationsContex {
  [key: string]: any
}

interface FormContextType {
  network: any
  formTitle: string
  currentStep: number
  sectionsNumber: number
  generatePDF: () => React.ReactElement | null
  actionHandlers: FormActionHandlers
  activePrequalificationsMap: PrequalificationsContex
  mainConnectedObject: 'Opportunity' | 'Case' | 'FGM_Base__Grantee_Report__c' | 'Pre_Qualification__c' | 'Resource__c'
  formViewType: 'editable' | 'printable' | 'pdf' | 'fillable-pdf'
  connectedMap: ConnectedMap | undefined
}

const FormContext = React.createContext<FormContextType>({
  network: null,
  formTitle: '',
  currentStep: 0,
  sectionsNumber: 1,
  generatePDF: () => null,
  actionHandlers: {},
  activePrequalificationsMap: {},
  mainConnectedObject: 'Opportunity',
  formViewType: 'editable',
  connectedMap: undefined
})

export function useFormContext (): FormContextType {
  const value = React.useContext(FormContext)
  if (value == null) {
    throw new Error('useSession must be wrapped in a <SessionProvider />')
  }
  return value
}

export function FormContextProvider (
  props: React.PropsWithChildren<FormContextType>
): React.Provider<FormContextType> {
  return (
    <FormContext.Provider
      value={{
        ...props
      }}
    >
      {props.children}
    </FormContext.Provider>
  )
}
